import { LayoutContainerEnum } from '../../enum/layout-container.enum';
import { SerializedLayoutInterface } from '../../interface/serialized/serialized-layout.interface';
import { ExportOptionsEnum } from '../../enum/export-options.enum';

export class Layout {
  public endPoint = '';
  public container = LayoutContainerEnum.masterDetail;
  public urlGdx = '';
  public pagination = 50;
  public directSearch = false;
  public exportOptions = [ExportOptionsEnum.csv, ExportOptionsEnum.pdf];
  public exportGroups: string[] = [];
  public directEdit = false;

  constructor(endPoint: string) {
    this.endPoint = endPoint;
  }

  public serialize(): SerializedLayoutInterface {
    if (!this.endPoint) {
      return null;
    }
    return {
      endPoint: this.endPoint,
      container: this.container,
      urlGdx: this.urlGdx,
      exportOptions: this.exportOptions,
      pagination: this.pagination,
      directSearch: this.directSearch,
      exportGroups: this.exportGroups,
    };
  }

  public hasAccessToExport(userGroups: string[]): boolean {
    if (this.exportGroups.length === 0) {
      return true;
    }
    return this.exportGroups.some((group) => userGroups.includes(group));
  }
}
